import React from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';
import { contactInfo, logoWhite } from '../mock';

// Lucide doesn't have a TikTok icon; small inline SVG
const TikTokIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.6 6.7a5 5 0 0 1-3.1-1.2 5 5 0 0 1-1.8-3H11v12.3a2.7 2.7 0 1 1-2.7-2.7c.3 0 .6.05.9.13V8.84a6 6 0 1 0 5 5.9V9.55a8 8 0 0 0 5.4 1.6V7.3a5.1 5.1 0 0 1 0-.6z" />
  </svg>
);

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0f0f0f] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-3 gap-10 pb-10 border-b border-white/10">
          <div>
            <img
              src={logoWhite}
              alt="The Fleetwood Mac Experience"
              className="h-16 w-auto mb-5"
            />
            <p className="text-[14px] text-white/60 leading-relaxed max-w-xs">
              The UK's premier Fleetwood Mac tribute band. A joyful live theatre
              show celebrating timeless music.
            </p>
          </div>

          <div>
            <p className="text-[11px] tracking-[0.3em] text-[#e6396b] font-semibold mb-4">
              EXPLORE
            </p>
            <ul className="space-y-2.5">
              {[
                ['About', '#about'],
                ['The Band', '#band'],
                ['Setlist', '#setlist'],
                ['Gallery', '#gallery'],
                ['Upcoming Shows', '#dates'],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="text-[14px] text-white/70 hover:text-[#e6396b] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[11px] tracking-[0.3em] text-[#e6396b] font-semibold mb-4">
              GET IN TOUCH
            </p>
            <p className="text-[14px] text-white/70 leading-relaxed">
              {contactInfo.addressLines.join(' · ')}
            </p>
            <a
              href={`mailto:${contactInfo.email}`}
              className="block mt-3 text-[14px] text-white hover:text-[#e6396b] transition-colors"
            >
              {contactInfo.email}
            </a>
            <a
              href={`tel:${contactInfo.phoneRaw}`}
              className="block mt-1 text-[14px] text-white hover:text-[#e6396b] transition-colors"
            >
              {contactInfo.phone}
            </a>

            <div className="flex items-center gap-3 mt-5">
              <a
                href={contactInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full border border-white/20 hover:border-[#e6396b] hover:bg-[#e6396b] flex items-center justify-center transition-colors"
              >
                <Facebook size={16} />
              </a>
              <a
                href={contactInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full border border-white/20 hover:border-[#e6396b] hover:bg-[#e6396b] flex items-center justify-center transition-colors"
              >
                <Instagram size={16} />
              </a>
              <a
                href={contactInfo.social.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                className="w-9 h-9 rounded-full border border-white/20 hover:border-[#e6396b] hover:bg-[#e6396b] flex items-center justify-center transition-colors"
              >
                <TikTokIcon size={15} />
              </a>
              <a
                href={contactInfo.social.youtube}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="w-9 h-9 rounded-full border border-white/20 hover:border-[#e6396b] hover:bg-[#e6396b] flex items-center justify-center transition-colors"
              >
                <Youtube size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[12px] text-white/50">
            © {year} David Graham Entertainment Ltd. All rights reserved.
          </p>
          <p className="text-[12px] text-white/40">
            The Fleetwood Mac Experience — A celebration of timeless music.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
